import React, { Suspense } from "react";
import { I18nextProvider } from "react-i18next";
import { createRoot } from "react-dom/client";

import App from "./App";
import i18n from "./i18n";

import "./i18n";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <Suspense>
        <App />
      </Suspense>
    </I18nextProvider>
  </React.StrictMode>
);
